import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { ArticulosGuardados } from '../../../../../../core/model/DataCart';
import { ArticulosGuardadosService } from '../../../../../../services/generar-pedido/cart/articulos-guardados.service';
import { CartService } from '../../../../../../services/generar-pedido/cart/cart.service';

@Component({
  selector: 'app-save-later',
  templateUrl: './save-later.component.html',
  styleUrls: ['./save-later.component.scss']
})
export class SaveLaterComponent implements OnInit {

  constructor(
    private articuloGuardadosService: ArticulosGuardadosService,
    private cartService: CartService
  ) { }

  public listArtGuardados$: Observable<ArticulosGuardados[]>;
  public claveDelete: string;
  public isCedis: string;

  ngOnInit(): void {
    this.listArtGuardados$ = this.articuloGuardadosService.articulosGuardados$;
  }

  deleteItem(item): void {
    this.claveDelete = item.ClaveArticuloProveedor;
    this.isCedis = item.isCedis;

    this.articuloGuardadosService.removeItemToArticuloGuardado(item).subscribe((res) => {
      if (res.error === false) {
        this.getArticuloGuardado();
        this.claveDelete = '';
        this.isCedis = 'false';
      }
    });
  }

  public getArticuloGuardado(): void {
    this.articuloGuardadosService.getArticulosGuardados().subscribe((item) => {
      //  if (item.error === false) {
      //     // this.articuloGuardadosService.updateArtGurdados$(item.articulosGuardados);
      //   }
    });
  }

  public moverAlCarrito(item?: any): void {
    const existencias = Boolean(JSON.parse(item.isCedis)) ? item.TotalExistencias : item.TotalExistencias;
    // console.log(item.CANT_CAR, '<=', existencias);
    if (1 <= Number(existencias)) {
      // console.log('emtrp__')
      const dataArticulo: any = {
        ClaveArticulo: item.ClaveArticuloProveedor,
        Cantidad: 1, // item.CANT_CAR,
        AlmacenID: 1,
        isCedis: Boolean(JSON.parse(item.isCedis))
      };
      // console.log(dataArticulo);
      this.cartService.addItemCart(dataArticulo, item).subscribe(result => {
        this.getCart();
        this.deleteItem(item);
      });
    }
  }

  public getCart(): void {
    this.cartService.getminiCart().subscribe(result => {
    });
  }
}
